import React, { useState } from 'react';

const PALETTE = [
  '#48bb78', '#f6ad55', '#63b3ed', '#d6bcfa',
  '#fc8181', '#4fd1c5', '#f687b3', '#68d391',
  '#fbd38d', '#b794f4', '#90cdf4', '#feb2b2',
];

export default function PieChart({ data, size = 180, label, formatValue }) {
  const [hovered, setHovered] = useState(null);
  const total = data.reduce((sum, d) => sum + d.value, 0);
  if (total === 0) return null;

  const cx = size / 2;
  const cy = size / 2;
  const r = (size / 2) - 8;

  let currentAngle = -Math.PI / 2;
  const slices = data.map((d, i) => {
    const pct = d.value / total;
    const angle = pct * 2 * Math.PI;
    const startAngle = currentAngle;
    const endAngle = currentAngle + angle;
    currentAngle = endAngle;

    const largeArc = angle > Math.PI ? 1 : 0;
    const x1 = cx + r * Math.cos(startAngle);
    const y1 = cy + r * Math.sin(startAngle);
    const x2 = cx + r * Math.cos(endAngle);
    const y2 = cy + r * Math.sin(endAngle);

    const path = data.length === 1
      ? `M ${cx} ${cy - r} A ${r} ${r} 0 1 1 ${cx - 0.001} ${cy - r} Z`
      : `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z`;

    return {
      path,
      color: d.color || PALETTE[i % PALETTE.length],
      label: d.label,
      value: d.value,
      pct: (pct * 100).toFixed(1),
    };
  });

  return (
    <div>
      {label && (
        <h4 style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 8 }}>{label}</h4>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <svg width={size} height={size} style={{ flexShrink: 0 }}>
          {slices.map((s, i) => (
            <path
              key={i}
              d={s.path}
              fill={s.color}
              stroke="var(--bg-primary)"
              strokeWidth="2"
              opacity={hovered !== null && hovered !== i ? 0.4 : 1}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{ cursor: 'pointer', transition: 'opacity 0.2s' }}
            />
          ))}
          {hovered !== null && (
            <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle"
              fill="var(--text-primary)" fontSize="14" fontWeight="700"
            >
              {slices[hovered].pct}%
            </text>
          )}
        </svg>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12 }}>
          {slices.map((s, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 6,
              opacity: hovered !== null && hovered !== i ? 0.4 : 1,
              transition: 'opacity 0.2s', cursor: 'pointer',
            }}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{
                width: 10, height: 10, borderRadius: 2,
                background: s.color, flexShrink: 0,
              }} />
              <span style={{ color: 'var(--text-secondary)' }}>
                {s.label}
              </span>
              <span style={{ color: 'var(--text-muted)', marginLeft: 'auto', whiteSpace: 'nowrap' }}>
                {formatValue ? formatValue(s.value) : s.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
